import { makeStyles } from '@mui/styles';

export const useFirmInfoHeaderStyles = makeStyles(() => ({
  firmName: {
    fontWeight: 700,
    fontSize: '1rem',
    marginBottom: '1rem',
  },
  companyName: {
    fontWeight: 700,
    fontSize: '2rem',
    marginBottom: '1rem',
  },
  infoText: {
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: '1.188rem',
    whiteSpace: 'nowrap',
  },
  container: {
    marginRight: '3rem',
  },
}));
